import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Package, ArrowRight } from "lucide-react";
import { api, GHS } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { STATUS_LABEL, STATUS_COLOR } from "@/lib/status";

export default function Dashboard() {
  const { user } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders").then((r) => setOrders(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="mx-auto max-w-5xl px-6 py-12">
      <div className="flex items-center gap-4">
        <div className="w-14 h-14 rounded-full bg-brand text-brand-bg flex items-center justify-center font-display text-2xl">
          {(user?.name || "U").charAt(0).toUpperCase()}
        </div>
        <div>
          <h1 className="font-display text-3xl text-brand leading-none" data-testid="dashboard-username">Hello, {user?.name?.split(" ")[0] || "Farmer"}</h1>
          <p className="text-sm text-brand-muted mt-1">{user?.email}</p>
        </div>
      </div>

      <h2 className="font-display text-2xl text-brand mt-12 mb-5">Your Orders</h2>

      {loading ? (
        <div className="py-16 flex justify-center"><Loader2 className="w-7 h-7 animate-spin text-brand" /></div>
      ) : orders.length === 0 ? (
        <div className="bg-white border border-brand/10 rounded-sm p-10 text-center">
          <Package className="w-10 h-10 text-brand-muted mx-auto opacity-40" />
          <p className="mt-4 text-brand-muted">You haven't placed any orders yet.</p>
          <Link to="/shop" className="inline-block mt-4 text-brand font-medium hover:underline" data-testid="dashboard-shop-link">Start shopping →</Link>
        </div>
      ) : (
        <div className="space-y-4" data-testid="orders-list">
          {orders.map((o) => (
            <Link key={o.order_id} to={`/orders/${o.order_id}`} data-testid={`order-row-${o.order_id}`}
              className="block bg-white border border-brand/10 rounded-sm p-5 hover:shadow-md transition-shadow">
              <div className="flex items-center justify-between flex-wrap gap-3">
                <div>
                  <p className="font-medium text-brand">Order #{o.order_id}</p>
                  <p className="text-xs text-brand-muted mt-0.5">{new Date(o.created_at).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" })} · {o.items.length} item(s)</p>
                </div>
                <span className={`text-xs font-semibold px-3 py-1 rounded-full ${STATUS_COLOR[o.status]}`} data-testid={`order-status-${o.order_id}`}>{STATUS_LABEL[o.status]}</span>
                <div className="flex items-center gap-3">
                  <span className="font-bold text-brand">{GHS(o.total)}</span>
                  <ArrowRight className="w-4 h-4 text-brand-muted" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
